class FormOptionsSidebar extends Drawer {
  constructor() {
    super();
    const mainContent = document.querySelector('main-content');
    mainContent.appendChild(this);

    this.sidebarInputField = document.querySelector(this.dataset.inputId);
    this.sidebarInputField.addEventListener('click', () => this.open());
    this.inputOptions = this.querySelectorAll('[data-option-value]');
    this.applyButton = this.querySelector('.form-options-sidebar__apply');
    this.selectedOption = '';

    this.addEventListener('click', event => {
      const selectedOption = event.target.closest('[data-option-value]');
      if (selectedOption) {
        this.selectedOption = selectedOption.dataset.optionValue;
        this.updateSelectedOption(selectedOption);
        this.applyButton.disabled = false;
      } else if (event.target.closest('.form-options-sidebar__apply')) {
        this.sidebarInputField.value = this.selectedOption;
        this.close();
      } else if (! event.target.closest('.drawer__inner')) {
        this.close();
      }
    });
  }

  updateSelectedOption(selectedOption) {
    this.inputOptions.forEach(option => {
      option.classList.toggle('selected', option === selectedOption);
    });
  }
}
  
customElements.define('form-options-sidebar', FormOptionsSidebar);